
import React from 'react';
import { Eye, Zap, Image, Code, Brush, MessageSquare } from 'lucide-react';

interface ChatFooterStatsProps {
  viewCount: number;
  tokensUsed: number;
  imageCount: number;
  codeCount: number;
  canvasCount: number;
  messageCount: number;
}

const ChatFooterStats = ({ 
  viewCount,
  tokensUsed,
  imageCount,
  codeCount,
  canvasCount,
  messageCount
}: ChatFooterStatsProps) => {
  return (
    <>
      <div className="flex items-center space-x-3 text-muted-foreground text-xs">
        <div className="flex items-center">
          <Eye className="h-3.5 w-3.5 mr-1" />
          <span>{viewCount || 0}</span>
        </div>
        <div className="flex items-center">
          <Zap className="h-3.5 w-3.5 mr-1" />
          <span>{tokensUsed || 0}</span>
        </div>
      </div>
      
      <div className="flex items-center space-x-3 text-muted-foreground text-xs">
        {(imageCount > 0) && (
          <div className="flex items-center">
            <Image className="h-3.5 w-3.5 mr-1" />
            <span>{imageCount}</span>
          </div>
        )}
        {(canvasCount > 0) && (
          <div className="flex items-center">
            <Brush className="h-3.5 w-3.5 mr-1" />
            <span>{canvasCount}</span>
          </div>
        )}
        {codeCount > 0 && (
          <div className="flex items-center">
            <Code className="h-3.5 w-3.5 mr-1" />
            <span>{codeCount}</span>
          </div>
        )}
        <div className="flex items-center">
          <MessageSquare className="h-3.5 w-3.5 mr-1" />
          <span>{messageCount || 0}</span>
        </div>
      </div>
    </>
  );
};

export default ChatFooterStats;
